import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { InventoryIncentivesEntities } from 'client/data/models/inventory-incentives';
import { isOtherRebate } from 'site-modules/shared/utils/incentives/incentives-service';
import { PriceCheckerIncentivesListItem } from 'site-modules/shared/components/price-checker/price-checker-incentives-list-item/price-checker-incentives-list-item';
import { Incentive } from 'site-modules/shared/constants/car-buying/models';

export const PriceCheckerIncentivesList = memo(
  ({
    incentives = [],
    onClick = null,
    selectedIncentives = [],
    isLeaseView = false,
    incompatibleIncentivesIds = {},
    isNonTMVDealer = false,
    isFirstItemInitiallyFocused = false,
  }) => {
    return (
      <ul className="list-unstyled text-gray-darker p-0 w-100 pt-0_25 ps-0_25 mb-0">
        {incentives.map((incentive, index) => (
          <PriceCheckerIncentivesListItem
            isInitiallyFocused={isFirstItemInitiallyFocused && index === 0}
            key={get(incentive, 'id')}
            incentive={incentive}
            onClick={onClick}
            selectedIncentives={selectedIncentives}
            isLeaseView={isLeaseView}
            incompatibleIncentivesIds={incompatibleIncentivesIds}
            isUnselectable={isOtherRebate(incentive)}
            isNonTMVDealer={isNonTMVDealer}
          />
        ))}
      </ul>
    );
  }
);

PriceCheckerIncentivesList.displayName = 'PriceCheckerIncentivesList';

PriceCheckerIncentivesList.propTypes = {
  incentives: PropTypes.oneOfType([
    PropTypes.arrayOf(Incentive),
    PropTypes.arrayOf(InventoryIncentivesEntities.Incentive),
  ]),
  selectedIncentives: PropTypes.oneOfType([
    PropTypes.arrayOf(Incentive),
    PropTypes.arrayOf(InventoryIncentivesEntities.Incentive),
  ]),
  onClick: PropTypes.func,
  isLeaseView: PropTypes.bool,
  incompatibleIncentivesIds: PropTypes.shape({}),
  isNonTMVDealer: PropTypes.bool,
  isFirstItemInitiallyFocused: PropTypes.bool,
};
